//浅复制
export function copyArr(arr) {
  return arr.map(e => {
    return Object.assign({}, e)
  })
}
//根据code换取name
export function itemFilter(value, filterArr, allSelect) {
  for (let index in allSelect[filterArr])
    if (allSelect[filterArr][index].code == value) {
      return allSelect[filterArr][index].text
    }
}
//获取当前系统时间
export function getNowDate() {
  var date = new Date()
  var sign1 = '.'
  var year = date.getFullYear() // 年
  var month = date.getMonth() + 1 // 月
  var day = date.getDate() // 日
  // 给一位数数据前面加 “0”
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  var currentdate = year + sign1 + month + sign1 + day
  return currentdate
}
//时间戳转换成年月日
export function timestampToDate(timestamp, sign) {
  var date = new Date(timestamp)
  var sign1 = sign || '.'
  var year = date.getFullYear() // 年
  var month = date.getMonth() + 1 // 月
  var day = date.getDate() // 日
  // 给一位数数据前面加 “0”
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  var currentdate = year + sign1 + month + sign1 + day
  return currentdate
}

//数字格式化
export function number_format(number, decimals = 2, dec_point, thousands_sep) {
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * dec_point：小数点符号
   * thousands_sep：千分位符号
   * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec)
      return '' + Math.ceil(n * k) / k
    }

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }

  return s.join(dec)
}

export function unit(priceUnit, number) {
  if (priceUnit) {
    return number_format(number)
  } else {
    return div(number, 10000).toFixed(2)
  }
}

import { BigNumber } from 'bignumber.js'

//加法
export function plus(x, y, a) {
  x = Number(x) || 0
  y = Number(y) || 0
  if (a) {
    return new BigNumber(x)
      .plus(y)
      .decimalPlaces(a)
      .toNumber()
  } else {
    return new BigNumber(x).plus(y).toNumber()
  }
}

//减法
export function minus(x, y, a) {
  x = Number(x) || 0
  y = Number(y) || 0
  //x减数，y被减数，a精确位数
  if (a) {
    return new BigNumber(x)
      .minus(y)
      .decimalPlaces(a)
      .toNumber()
  } else {
    return new BigNumber(x).minus(y).toNumber()
  }
}

//乘法
export function multipliedBy(x, y, a) {
  x = Number(x) || 0
  y = Number(y) || 0
  if (a) {
    return new BigNumber(x)
      .multipliedBy(y)
      .decimalPlaces(a)
      .toNumber()
  } else {
    return new BigNumber(x).multipliedBy(y).toNumber()
  }
}

//除法
export function div(x, y, a) {
  x = Number(x) || 0
  y = Number(y) || 0
  //x除数，y被除数，a精确位数
  if (a) {
    return new BigNumber(x)
      .div(y)
      .decimalPlaces(a)
      .toNumber()
  } else {
    return new BigNumber(x).div(y).toNumber()
  }
}

// 获取两个日期直接间隔多少小时多少分钟
// var dt1 = "2009-11-5 10:30"
//    var dt2 = "2009-11-8 9:20"
export function getHoursDiff(dt1, dt2) {
  if (typeof dt1 == 'string') {
    dt1 = new Date(dt1.replace(/-/, '/'))
    dt2 = new Date(dt2.replace(/-/, '/'))
  }
  var res = dt2 - dt1
  if (isNaN(res)) {
    throw Error('invalid dates arguments')
  }
  return res / (1000 * 60 * 60)
}
